import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'
import { getProvider } from '@/apollo'

const initialState = {
  loading: false,
  targetTariff: null,
  targetTariffoptions: [],
  targetPromotions: [],
  volume: {
    amount: 0,
    promoAmount: 0,
    unit: null
  },
  limitedVolume: {
    promoAmount: 0,
    duration: 0,
    durationUnit: null,
    unit: null
  },
  price: {
    amount: 0
  },
  promoPrice: {
    promoAmount: 0,
    duration: 0,
    durationUnit: null
  },
  additionalPriceStairways: [],
  startingBonus: 0
}

const MnpInCartModule = {
  namespaced: true,
  state: initialState,
  getters: {
    price: state => state.price,
    volume: state => state.volume,
    limitedPrice: state => state.limitedPrice,
    promoPrice: state => state.promoPrice,
    limitedVolume: state => state.limitedVolume,
    startingBonus: state => state.startingBonus,
    targetTariff: state => state.targetTariff,
    targetPromotions: state => state.targetPromotions
  },
  actions: {
    async queryCart ({ commit, state, rootState, dispatch }, { tariffId, tariffoptionIds, skipCalculation = false, mnpProvider, promoCode = '' }) {
      let tariffoptions = []
      if (tariffoptionIds && tariffoptionIds.length > 0) {
        tariffoptions = tariffoptionIds.map(id => { return { tariffoptionId: id } })
      }
      const product = {
        tariffIdentifier: tariffId,
        tariffoptions: tariffoptions,
        triggerDefault: false
      }
      const variables = {
        cart: {
          orderContext: { market: 'PUC' },
          product: product,
          network: {
            mnp: true,
            providerKey: mnpProvider.key,
            networkKey: mnpProvider.network
          }
        }
      }
      commit('clearMessages', {}, { root: true })
      const apolloClient = getProvider().defaultClient
      return apolloClient.query({
        query: gql`query mnpInCart ($cart: CartInput!) {
          mnpInCart (cart: $cart) {
            targetTariff {
              ...cartTariff
            }
            targetTariffoptions {
              bookableTariffoptions {
                ...cartTariffoption
              }
            }
            targetPromotion {
              ...cartPromo
            }
            prices {
              yearlyBasicFee
              yearlyBasicFeeFormatted
              totalMonthlyFee
              totalMonthlyFeeFormatted
              totalSinglePaymentFee
              totalSinglePaymentFeeFormatted
            }
            contractServices {
              inclusive {
                volume
              }
            }
            appliedDefaultType
            validationMessage
          }
        }
        fragment cartTariff on TargetTariff {
          baseTariffId
          basicFee
          name
          tariffId
          volumes {
            amount
            formattedUnit
            type
            unit
          }
        }
        fragment cartTariffoption on BookableTariffoption {
          price
          name
          tariffoptionId
          volumes {
            amount
            formattedUnit
            type
            unit
          }
        }
        fragment cartPromo on BookablePromotion {
          promotionId
          name
          incentives {
            id
            type
            ...on ServiceIncentive {
              service
            }
            ...on CreditIncentive {
              discount
              targetFee
            }
            ...on OtherIncentive {
              kind
            }
            ...on VolumeIncentive {
              amount
              unit
            }
          }
          notBookableWith
          requiredParameters
          duration {
            amount
            unit
            formattedUnit
          }
        }`,
        variables
      }).then((response) => {
        if (skipCalculation) {
          return true
        }
        let finalResult = {}
        dispatch('cart/processQueryResult', {
          tariff: response.data.mnpInCart.targetTariff,
          tariffoptions: response.data.mnpInCart.targetTariffoptions?.bookableTariffoptions,
          promotions: response.data.mnpInCart.targetPromotion
        }, { root: true }).then((result) => {
          finalResult = result
          commit('targetTariff', finalResult.targetTariff)
          commit('targetTariffoptions', finalResult.targetTariffoptions)
          commit('targetPromotions', finalResult.targetPromotions)
          commit('promoBenefits', finalResult.promoBenefits)
        })
        return true
      }).catch((error) => {
        commit('resetState', null)
        splitError(error).forEach(e => commit('addError', e, { root: true }))
        return false
      })
    }
  },
  mutations: {
    targetTariff (state, tariff) {
      state.targetTariff = tariff
    },
    targetTariffoptions (state, tariffoptions) {
      state.targetTariffoptions = tariffoptions
    },
    targetPromotions (state, promotions) {
      state.targetPromotions = promotions
    },
    promoBenefits (state, { newVolume, newLimitedVolume, newPrice, newPromoPrice, additionalPriceStairways, newStartingBonus }) {
      state.volume = newVolume
      state.limitedVolume = newLimitedVolume
      state.price = newPrice
      state.promoPrice = newPromoPrice
      state.additionalPriceStairways = additionalPriceStairways
      state.startingBonus = newStartingBonus
    },
    resetState: (state) => {
      Object.assign(state, initialState)
    }
  }
}

export {
  MnpInCartModule
}
